export type FacilityType = 'warehouse' | 'ocean_port_terminal' | 'rail_ramp_terminal'

export type Facility = {
  uuid: string
  city: string
  state: string
  country: string
  companyName?: string
  zipcode: string
  address: string
  contacts: Array<Contact>
  defaultContactUuid?: string
  hoursOfOperations?: FacilityOperation
  warehouseName?: string | null
  warehouseUuid?: string | null
  warehouseId?: string | null
  timezone?: string
  type?: FacilityType
}

type FacilityOperation = {
  mode: string
  opens: string
  closes: string
  monday: boolean
  tuesday: boolean
  wednesday: boolean
  thursday: boolean
  friday: boolean
  saturday: boolean
  sunday: boolean
}

export type Contact = {
  uuid: string
  email: string
  name?: string
  phoneNumberExtension?: string
  phoneNumber: string
}

export function isPortFacility(facility?: Facility): boolean {
  return facility?.type === 'ocean_port_terminal' || facility?.type === 'rail_ramp_terminal'
}

export function isWarehouseFacility(facility?: Facility): boolean {
  return facility?.type === 'warehouse'
}
